angular.module('shared').factory('WaiverService', ["$q", "$http", function($q, $http) {
  return {
    getParentDetails: function(waiver) {
      var fields, parent;
      parent = waiver.signed_waiver_contacts_attributes[0];
      fields = _.compact(['email', this.isFieldAvailable(waiver, 'phone_number') && 'phone_number', this.isFieldAvailable(waiver, 'address') && 'address_line_1', this.isFieldAvailable(waiver, 'address') && 'address_line_2', this.isFieldAvailable(waiver, 'address') && 'address_suburb', this.isFieldAvailable(waiver, 'address') && 'address_postcode', this.isFieldAvailable(waiver, 'address') && 'address_state']);
      return _.pick(parent, fields);
    },
    prepopulateChildDetails: function(waiver) {
      return waiver.signed_waiver_contacts_attributes.forEach((contact, index) => {
        var parent;
        parent = this.getParentDetails(waiver);
        if (index !== 0) {
          contact.email || (contact.email = parent.email);
          contact.phone_number || (contact.phone_number = parent.phone_number);
          contact.address_line_1 || (contact.address_line_1 = parent.address_line_1);
          contact.address_line_2 || (contact.address_line_2 = parent.address_line_2);
          contact.address_suburb || (contact.address_suburb = parent.address_suburb);
          contact.address_postcode || (contact.address_postcode = parent.address_postcode);
          return contact.address_state || (contact.address_state = parent.address_state);
        }
      });
    },
    syncContactFields: function(waiver) {
      return function(contact, oldContact) {
        var watchFields;
        if (!contact || !oldContact) {
          return;
        }
        watchFields = ['email', 'phone_number', 'address_line_1', 'address_line_2', 'address_suburb', 'address_state', 'address_postcode'];
        return watchFields.forEach(function(field) {
          if (contact[field] !== oldContact[field]) {
            return waiver.signed_waiver_contacts_attributes.forEach(function(c, index) {
              if (index > 0 && c[field] === oldContact[field]) {
                return c[field] = contact[field];
              }
            });
          }
        });
      };
    },
    initPaymentDetails: function(waiver) {
      var accountNumber, cardNumber, defaultPaymentMethod, ref, waiverWallet, walletDetails;
      waiverWallet = waiver.signed_waiver_wallet_detail_attributes;
      if (waiver.signed_waiver_form_attributes.payment_authority_active) {
        if ((ref = waiver.signed_waiver_form_attributes.restrict_payment_methods_to) != null ? ref.length : void 0) {
          waiverWallet.disablePaymentMethodSelect = true;
        }
        defaultPaymentMethod = (function() {
          var ref1;
          switch (false) {
            case !((ref1 = waiver.signed_waiver_form_attributes.restrict_payment_methods_to) != null ? ref1.length : void 0):
              return waiver.signed_waiver_form_attributes.restrict_payment_methods_to[0];
            case !waiver.signed_waiver_form_attributes.payment_authority_preferred_payment_method:
              return waiver.signed_waiver_form_attributes.payment_authority_preferred_payment_method;
            default:
              return 'credit_card';
          }
        })();
        waiverWallet.payment_method || (waiverWallet.payment_method = defaultPaymentMethod);
        waiverWallet.payment_method_changed = true;
        walletDetails = {
          payment_method: waiverWallet.payment_method,
          editable: !waiverWallet.customer_ref || !waiverWallet.last4,
          cardValid: true,
          disablePaymentMethodSelect: waiverWallet.disablePaymentMethodSelect
        };
        if (waiverWallet.last4) {
          if (waiverWallet.payment_method === 'credit_card') {
            cardNumber = `xxxx xxxx xxxx ${waiverWallet.last4}`;
          }
          if (waiverWallet.payment_method === 'bank_account') {
            accountNumber = `xxxx xxxx xxxx ${waiverWallet.last4}`;
          }
          waiverWallet.payment_method_changed = false;
          angular.extend(walletDetails, {
            cardNumber: cardNumber,
            expiryMonth: parseInt(waiverWallet.exp_month, 10) || '',
            expiryYear: parseInt(waiverWallet.exp_year, 10) || '',
            nameOnCard: waiverWallet.full_name,
            bsb: waiverWallet.bsb,
            accountNumber: accountNumber,
            accountName: waiverWallet.full_name
          });
        }
        return walletDetails;
      }
    },
    getNewPaymentDetails: function(waiver) {
      var defaultPaymentMethod, disablePaymentMethodSelect, ref, walletDetails;
      waiver.signed_waiver_wallet_detail_attributes.payment_method_changed = true;
      if ((ref = waiver.signed_waiver_form_attributes.restrict_payment_methods_to) != null ? ref.length : void 0) {
        disablePaymentMethodSelect = true;
        defaultPaymentMethod = waiver.signed_waiver_form_attributes.restrict_payment_methods_to[0];
      }
      return walletDetails = {
        editable: true,
        payment_method: defaultPaymentMethod || 'credit_card',
        disablePaymentMethodSelect: disablePaymentMethodSelect
      };
    },
    isBankAccountProviderAvailable: function(provider) {
      return provider === 'ezidebit';
    },
    isCreditCardProviderAvailable: function(provider) {
      return provider === 'ezidebit' || provider === 'stripe';
    },
    isFieldRequired: function(waiver, field, first) {
      var fields;
      fields = waiver.signed_waiver_form_attributes.required_fields;
      return fields[field] === 'required_for_all_signees' || fields[field] === 'required_for_primary_signee' && first;
    },
    isFieldAvailable: function(waiver, field) {
      return waiver.signed_waiver_form_attributes.required_fields[field] !== 'hidden';
    },
    hasPayment: function(waiver) {
      return waiver.signed_waiver_contacts_attributes.find(function(contact) {
        var plan;
        plan = waiver.signed_waiver_form_attributes.membership_plan_options.find(function(m) {
          return m.id === contact.membership_plan_id;
        });
        return !contact._destroy && ((plan != null ? plan.cost_upfront : void 0) > 0 || (plan != null ? plan.cost_repeat : void 0) > 0);
      });
    },
    getEzidebitFees: function(waiver, gymId) {
      var deferred, excludeFee, ref;
      deferred = $q.defer();
      if (((ref = waiver.signed_waiver_form_attributes) != null ? ref.membership_options_active : void 0) && waiver.gym_payment_provider === 'ezidebit') {
        excludeFee = waiver.primary_signee_active_on_ezidebit ? "&exclude_setup_fee=true" : '';
        $http.get(`/fee_schedules?gym_id=${gymId}${excludeFee}`).then(function(respose) {
          return deferred.resolve(respose.data.fees);
        });
      }
      return deferred.promise;
    },
    setEzidebitCustomerContactDetails: function(waiver, country) {
      var deferred, emailPattern, primaryContact, url;
      deferred = $q.defer();
      if (country === 'AU' || country === 'NZ') {
        primaryContact = _.find(waiver.signed_waiver_contacts_attributes, function(contact) {
          return contact.primary;
        });
        emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        if (emailPattern.test(primaryContact.email.trim())) {
          primaryContact.cleanContactEmail = primaryContact.email.trim();
        }
        if (primaryContact.phone_number) {
          url = `/phone_numbers/localize?country_code=${country}&phone_number=${primaryContact.phone_number}`;
          $http.get(url).then(function(response) {
            primaryContact.cleanContactPhoneNumber = response.data.localized_phone_number;
            return deferred.resolve();
          }, function() {
            return deferred.resolve();
          });
        } else {
          deferred.resolve();
        }
      } else {
        deferred.resolve();
      }
      return deferred.promise;
    },
    getPreselectedMembership: function(waiver, params) {
      var clickAndPayPlan, defaultMembershipPlan, defaultMembershipPlanId, filteredPlans, plans, preselectedMembershipPlanId, ref, ref1, waiverForm;
      defaultMembershipPlanId = waiver.signed_waiver_form_attributes.default_membership_plan_id;
      waiverForm = waiver.signed_waiver_form_attributes;
      plans = waiverForm.membership_plan_options;
      filteredPlans = _.filter(plans, function(plan) {
        return !plan.purchase_limit || plan.purchases_remaining;
      });
      if (!(waiverForm.membership_options_active && plans.length)) {
        return;
      }
      preselectedMembershipPlanId = waiverForm.family_membership_strategy === 'every_attendee_pays_membership' ? (ref = waiver.signed_waiver_contacts_attributes[1]) != null ? ref.membership_plan_id : void 0 : (ref1 = waiver.signed_waiver_contacts_attributes[0]) != null ? ref1.membership_plan_id : void 0;
      if (preselectedMembershipPlanId) {
        return _.find(filteredPlans, function(plan) {
          return plan.id === preselectedMembershipPlanId;
        });
      }
      if (params != null ? params.clickAndPayId : void 0) {
        clickAndPayPlan = _.find(filteredPlans, function(plan) {
          return plan.id === params.clickAndPayId;
        });
        if (clickAndPayPlan) {
          return clickAndPayPlan;
        }
      }
      if (defaultMembershipPlanId) {
        defaultMembershipPlan = _.find(filteredPlans, function(plan) {
          return plan.id === defaultMembershipPlanId;
        });
        if (defaultMembershipPlan) {
          return defaultMembershipPlan;
        }
      }
      return filteredPlans[0];
    }
  };
}]);
